import { useId } from "react";
import { Button } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { formatTranslation } from "../../../../shared/utils/translationUtils";
import styles from "./style.module.less";

export interface ErrorAutoScreenProps {
  onRetry: () => void;
  onClose: () => void;
  isRetrying?: boolean;
}

export const ErrorAutoScreen = ({
  onRetry,
  onClose,
  isRetrying = false,
}: ErrorAutoScreenProps): JSX.Element => {
  const { t } = useTranslation();
  const headingId = useId();

  return (
    <div
      className={styles.container}
      role="alert"
      aria-labelledby={headingId}
      aria-busy={isRetrying}
    >
      <ExclamationCircleOutlined className={styles.icon} aria-hidden />
      <div className={styles.content}>
        <h3 id={headingId} className={styles.heading}>
          {formatTranslation(t("newRatesAndDosage.errorAutoScreen.title"))}
        </h3>
        <p className={styles.description}>
          {formatTranslation(t("newRatesAndDosage.errorAutoScreen.message"))}
        </p>
      </div>
      <div className={styles.actions}>
        <Button
          type="primary"
          className={styles.retry}
          loading={isRetrying}
          disabled={isRetrying}
          onClick={onRetry}
        >
          {formatTranslation(t("newRatesAndDosage.errorAutoScreen.tryAgain"))}
        </Button>
        <Button disabled={isRetrying} onClick={onClose}>
          {formatTranslation(t("newRatesAndDosage.errorAutoScreen.close"))}
        </Button>
      </div>
    </div>
  );
};
